export const ENDPOINTS = {
    VENTAS: {
        GET_BY_PEDIDO_ID: (pedidoId: number) => `api/ventas?pedidoId=${pedidoId}`,
        UPLOAD_COMPROBANTE: 'api/ventas/comprobante'
    }
};